<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2022-07-12 16:19:17
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2022-11-09 11:57:49
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/volvo202207/components/video.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
    视频模块
-->
<template>
  <div id="video">
    <video
      ref="video"
      v-if="src"
      data-v-3b1260f5=""
      id="vido_one"
      :src="src"
      controls="controls"
      webkit-playsinline=""
      :poster="poster"
      playsinline=""
      x5-video-player-type="h5"
      class="video__player poster"
    >
      抱歉，您的浏览器不支持内嵌视频
    </video>
    <img v-else :src="poster" />
  </div>
</template>
<script>
export default {
  props: ['poster', 'src'],
  mounted() {},
};
</script>
<style lang="less" scoped>
#video {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  box-sizing: border-box;
  border-radius: 6px;
}
video {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  display: block;
}
</style>